var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01 2.00042V2C1.01 1.17287 1.6794 0.5 2.5 0.5H18.5C19.3239 0.5 20 1.17614 20 2V14C20 14.8239 19.3239 15.5 18.5 15.5H2.5C1.67621 15.5 1.0001 14.824 1 14.0002C1 14.0001 1 14.0001 1 14L1.01 2.00042ZM18.765 4.424L19 4.27712V4V2V1.09788L18.235 1.576L10.5 6.41038L2.765 1.576L2 1.09788V2V4V4.27712L2.235 4.424L10.235 9.424L10.5 9.58962L10.765 9.424L18.765 4.424Z",
    fill: "#333333",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.1e1592e995bdc0564cf3813076398668.svg";
export { ForwardRef as ReactComponent };